
import Vue from 'vue'

import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { PartyStreetAddressModel } from '@ViewModels/PartyStreetAddressModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import { formatAddress } from '../Address/AddressUtilities'

export default Vue.extend({
   name: 'ShippingInputSummary',
   data() {
      return {
         step: 'shipping',
      }
   },
   computed: {
      visible(): boolean {
         return (
            this.$store.getters.requiresDelivery &&
            this.$store.state.step !== this.step &&
            this.$store.state.viewedSteps.includes(this.step)
         )
      },
      shippingAddress(): string {
         if (this.isSchoolOrder) {
            return this.schoolAddress
         }
         if (this.personalAddress) {
            return this.personalAddress
         }
         return 'Not set'
      },
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      isSchoolOrder(): boolean {
         return !this.purchase.IsPersonalOrder
      },
      isClickAndCollect(): boolean {
         return this.purchase.ClickAndCollect
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
      schoolAddress(): string {
         return this.modelData.SchoolId
            ? this.modelData.SchoolAddress
            : this.$store.state.schoolLookup.schoolAddress
      },
      personalAddress(): string {
         const addressId = this.purchase.ShippingAddressId
         if (addressId) {
            const addresses = this.$store.state.modelData.Addresses
            const address = addresses.find((a: PartyStreetAddressModel) => a.Id === addressId)
            if (address) {
               return address.FormattedAddress
            }
         } else if (
            this.purchase.ShippingAddress &&
            this.purchase.ShippingAddress.AddressLine1 &&
            this.purchase.ShippingAddress.AddressLine1.length > 2
         ) {
            return formatAddress(this.purchase.ShippingAddress)
         }
         return ''
      },
   },
   methods: {
      change() {
         this.$store.commit('setStep', this.step)
      },
   },
})
